export enum SmartModalAction {
  CONFIRMED = 'CONFIRMED',
  DISMISSED = 'DISMISSED',
  CLOSED = 'CLOSED',
  CHECKED = 'CHECKED',
}
